import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFormProps } from '../utils';

interface IEditClienteFormFields {
    id: string
    cnpj: string
    razaoSocial: string
    nomeFantasia?: string
    login: string
    vendedorId: number
    status: boolean
    vendedorNome: string
  
    ProdutosTiposConsumos: {
      IdProduto: number
      IdProdutoCliente?: number
      IdTipoConsumo: number
      TipoConsumoAtivo?: boolean
    }[]
  }

  const editClienteFormFieldsInitialState: IEditClienteFormFields = {
    id: '',
    cnpj: '',
    login: '',
    razaoSocial: '',
    vendedorId: 0,
    vendedorNome: '',
    status: false,
    ProdutosTiposConsumos: []
  }


interface IProdutoClienteState {
    editClienteForm: IFormProps<IEditClienteFormFields>
}

const initialState: IProdutoClienteState = {
    editClienteForm: {
        errors: [],
        fields: editClienteFormFieldsInitialState,
        touched: false,
        delivered: false
      },
}

const produtoClienteSlice = createSlice({
    name: 'ProdutoCliente',
    initialState,
    reducers: {
        setProdutoClienteState(state, action:PayloadAction<{
            ProdutosVinculados: {
                IdProduto: number
                IdProdutoCliente?: number
                IdTipoConsumo: number
                TipoConsumoAtivo?: boolean
            }[]
        
        }>) {
            state.editClienteForm.fields.ProdutosTiposConsumos = action.payload.ProdutosVinculados
        },
        // resetProdutoClienteState(state, action:PayloadAction<IProdutoCliente>) {
        //     state.editClienteForm.fields.ProdutosTiposConsumos = initialState.
        // }
    }
})

export const {
    setProdutoClienteState
} = produtoClienteSlice.actions

export const produtoClienteReducer = produtoClienteSlice.reducer